export const duration = 420
export const easing = "easeInOutQuad"
